<template>

<div class="pin text-block">

	<div class="pin-icon"></div>
	<h3 class="pin-text" v-html="$nl2br(item.content)"></h3>

</div>

</template>

<script>

export default {

	props: ['item']

}

</script>

<style scoped>

.pin {
	display: flex;
	flex-direction: row;
}

.pin-icon {
	width: 20px;
	height: 20px;
	margin-right: 10px;
	flex-shrink: 0;
	background-size: 17px 17px;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-image: url(~@/assets/text/pin.svg);
}

.pin-text {
	color: #707070;
	font-size: 18px;
	flex-grow: 1;
	line-height: 24px;
	margin-bottom: 5px;
}

.pin-text >>> a {
	color: #4082d3;
}

</style>
